<div class="grid">
  <div class="col-12 mb-2">
    <div class="card title-card">
      <div role="toolbar">
        <div class="flex align-items-center">
          <div>
            <i *ngIf="mode == 'create'" class="pi pi-plus-circle mr-1 title-card-icon"></i>
            <i *ngIf="mode == 'edit'" class="pi pi-pencil mr-1 title-card-icon"></i>
          </div>
          <div>
            <p class="mb-0 text-3xl title">
              {{(mode == 'create' ? 'misc.creation.asset' : 'misc.edition.asset') | transloco | capitalize}}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12 lg:col-4 xl:col-3">
    <p-timeline [value]="items" align="left" styleClass="timeline-hidden-opposite lg:pr-2">
      <ng-template pTemplate="marker" let-item>
        <span
          class="custom-marker p-shadow-1"
          [class]="(item.index != currentStep) ? (item.index < currentStep) ? 'step-completed' : 'step-inactive' : 'step-active'"
        >
          <i class="text-white" [ngClass]="(item.index >= currentStep) ? item.icon : 'pi pi-check'"></i>
        </span>
      </ng-template>
      <ng-template pTemplate="content" let-item>
        <div class="card flex justify-content-between align-items-center mb-4">
          <h4 [class]="(item.index != currentStep) ? 'step-text-inactive mb-0' : 'step-text-active mb-0'">
            {{item.label | transloco}}
          </h4>
          <i
            *ngIf="item.description"
            [class]="(item.index != currentStep) ? 'step-text-inactive mb-0' : 'step-text-active mb-0'"
            [pTooltip]="item.description | transloco"
            tooltipPosition="top"
            class="pi pi-info-circle text-xl"
            tooltipStyleClass="device-info-tooltip"
          ></i>
        </div>
      </ng-template>
    </p-timeline>
  </div>
  <div class="col-12 lg:col-8 xl:col-9" *ngIf="formLoaded">
    <div *ngIf="currentStep == 0">
      <app-assets-form-info
        [(asset)]="asset"
        [(template)]="template"
        [(defaultAssetRepresentation)]="defaultAssetRepresentation"
        [mode]="mode"
        (onNextStep)="nextStep()"
        (onCancel)="cancelAction()"
        (onTenantChange)="tenantChanged()"
      ></app-assets-form-info>
    </div>
    <div *ngIf="currentStep == 1">
      <app-assets-form-measurements
        [(assetMeasurements)]="assetMeasurements"
        [tenant]="asset.tenant"
        [mode]="mode"
        (onPreviousStep)="previousStep()"
        (onNextStep)="nextStep()"
        (onCancel)="cancelAction()"
      ></app-assets-form-measurements>
    </div>
    <div *ngIf="currentStep == 2">
      <app-assets-form-properties
        [(assetProperties)]="assetProperties"
        [tenant]="asset.tenant"
        [mode]="mode"
        (onPreviousStep)="previousStep()"
        (onNextStep)="nextStep()"
        (onCancel)="cancelAction()"
      ></app-assets-form-properties>
    </div>
    <div *ngIf="currentStep == 3">
      <div class="card">
        <div class="flex flex-column p-3">

          <h2>{{'model.asset' | transloco}} {{asset.alias}}</h2>

          <h4 class="mt-4 bold">{{'common.information' | transloco}}</h4>
          <div class="grid my-2">
            <div class="flex flex-column col-12 lg:col-6 xl:col-4">
              <div>
                <p class="bold p-0 m-0">{{'attribute.description' | transloco}}</p>
                <p [class.font-italic]="!asset.description">
                  {{asset.description ? asset.description : ("empty.description" | transloco)}}
                </p>
              </div>
              <div class="mt-3">
                <p class="bold p-0 m-0">{{'model.tenant' | transloco}}</p>
                <p>{{asset.tenant.name}}</p>
              </div>
              <div class="mt-3">
                <p class="bold p-0 m-0">{{'model.organization' | transloco}}</p>
                <p>{{asset.organization ? asset.organization.name : ('empty.organization' | transloco)}}</p>
              </div>
              <div class="mt-3">
                <p class="bold p-0 m-0">{{'attribute.representation' | transloco}}</p>
                <p [class.font-italic]="!asset.assetRepresentation">
                  {{asset.assetRepresentation ? asset.assetRepresentation.name : ('empty.representation' | transloco)}}
                </p>
              </div>
              <div *ngIf="'ROLE_SUPER_ADMIN' | userHasRole" class="mt-3">
                <p class="bold p-0 m-0">{{'model.defaultRepresentation' | transloco}}</p>
                <p [class.font-italic]="!defaultAssetRepresentation">
                  {{defaultAssetRepresentation ? defaultAssetRepresentation.name : ('empty.defaultRepresentation' | transloco)}}
                </p>
              </div>
            </div>
            <div class="col-12 lg:col-6 xl:col-8">
              <div id="confirmationMap"></div>
            </div>
          </div>

          <h4 class="mt-6 bold">{{'attribute.technicalDetails' | transloco}}</h4>
          <div class="my-2">
            <ngx-json-viewer *ngIf="asset.technicalDetails" [json]="asset.technicalDetails"></ngx-json-viewer>
            <p *ngIf="!asset.technicalDetails" class="text-center">
              <i>{{'empty.technicalDetails' | transloco}}</i>
            </p>
          </div>

          <h4 class="mt-6 bold">{{'model.sensors' | transloco}}</h4>
          <div class="my-2">
            <p-table [value]="assetMeasurements" *ngIf="assetMeasurements.length > 0">
              <ng-template pTemplate="header">
                <tr>
                  <th>{{'attribute.name' | transloco}}</th>
                  <th>{{'attribute.description' | transloco}}</th>
                  <th>{{'attribute.alias' | transloco}}</th>
                  <th>{{'model.measurementType' | transloco}}</th>
                  <th>{{'attribute.sampleRate' | transloco}}</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-measurement>
                <tr>
                  <td>
                    <span class="p-column-title bold">{{'attribute.name' | transloco}}</span>
                    {{measurement.name}}
                  </td>
                  <td>
                    <span class="p-column-title bold">{{'attribute.description' | transloco}}</span>
                    {{measurement.description}}
                  </td>
                  <td>
                    <span class="p-column-title bold">{{'attribute.alias' | transloco}}</span>
                    {{measurement.alias}}
                  </td>
                  <td>
                    <span class="p-column-title bold">{{'model.measurementType' | transloco}}</span>
                    {{measurement.measurementType.sensor}}
                  </td>
                  <td>
                    <span class="p-column-title bold">{{'attribute.sampleRate' | transloco}}</span>
                    {{measurement.sampleRate}}
                  </td>
                </tr>
              </ng-template>
            </p-table>
            <p *ngIf="assetMeasurements.length == 0" class="text-center"><i>{{'empty.sensors' | transloco}}</i></p>
          </div>

          <h4 class="mt-6 bold">{{'model.properties' | transloco}}</h4>
          <div class="my-2">
            <p-table [value]="assetProperties" *ngIf="assetProperties.length > 0">
              <ng-template pTemplate="header">
                <tr>
                  <th>{{'attribute.name' | transloco}}</th>
                  <th>{{'attribute.value' | transloco}}</th>
                  <th>{{'model.propertyType' | transloco}}</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-property>
                <tr>
                  <td>
                    <span class="p-column-title bold">{{'attribute.name' | transloco}}</span>
                    {{property.name}}
                  </td>
                  <td>
                    <span class="p-column-title bold">{{'attribute.value' | transloco}}</span>
                    {{property.value}}
                  </td>
                  <td>
                    <span class="p-column-title bold">{{'model.propertyType' | transloco}}</span>
                    {{property.propertyType?.name}} {{property.propertyType?.unit ? ('(' + property.propertyType.unit + ')') : ''}}
                  </td>
                </tr>
              </ng-template>
            </p-table>
            <p *ngIf="assetProperties.length == 0" class="text-center"><i>{{'empty.properties' | transloco}}</i></p>
          </div>

          <div class="mt-6">
            <div class="flex flex-column sm:flex-row justify-content-between">
              <div class="flex justify-content-between sm:justify-content-start sm:flex-order-1">
                <button
                  [label]="'common.previous' | transloco"
                  (click)="previousStep()"
                  pButton
                  pRipple
                  class="flex-1 sm:flex-none"
                  icon="pi pi-angle-left"
                  iconPos="left"
                ></button>
                <button
                  [label]="(mode == 'creation' ? 'common.create' : 'common.save') | transloco"
                  [loading]="persistingChanges"
                  (click)="persistAssetData()"
                  pButton
                  pRipple
                  class="p-button-primary ml-2 flex-1 sm:flex-none"
                ></button>
              </div>
              <button
                [label]="'common.cancel' | transloco"
                (click)="cancelAction()"
                pButton
                pRipple
                class="p-button-danger mt-2 sm:mt-0 sm:flex-order-0"
              ></button>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>
